var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "auto-height",
    {
      staticClass: "send-list-conversation-container",
      attrs: { margin: _vm.margin },
    },
    [
      _c("div", { staticClass: "row h-100" }, [
        _c(
          "div",
          { staticClass: "col d-flex flex-column h-100" },
          [
            _c(
              "div",
              {
                staticClass:
                  "pt-2 pb-2 mt-2 pl-1 pr-1 mb-2 bg-gray-300 font-weight-bold flex-shrink-0 flex-grow-0",
              },
              [
                _c("note-viewer", {
                  attrs: {
                    note: _vm.note,
                    "store-note-url": _vm.storeNoteUrl,
                    "read-only-notes": _vm.readOnlyNotes,
                    "send-list-id": _vm.sendListId,
                    "can-set-read-only-note": _vm.canSetReadOnlyNote,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("el-input", {
                  staticClass: "search-bar mb-2 mt-2",
                  attrs: {
                    clearable: true,
                    autofocus: true,
                    placeholder: "Search",
                  },
                  on: { input: _vm.onSearchChanged },
                  model: {
                    value: _vm.pendingSearch,
                    callback: function ($$v) {
                      _vm.pendingSearch = $$v
                    },
                    expression: "pendingSearch",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("list", {
              ref: "list",
              staticClass: "list",
              attrs: { url: _vm.url, "is-edit": _vm.isEdit },
              on: {
                select: _vm.onSelect,
                edit: _vm.onEdit,
                delete: _vm.onDelete,
                "open-chat": _vm.onOpenChat,
                restore: _vm.onRestore,
                move: _vm.onMove,
                "refresh-start": _vm.onListRefreshStarted,
                "refresh-finish": _vm.onListRefreshFinished,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }